import { HostListener, Injectable } from "@angular/core";

@Injectable()
export abstract class ComponentCanDeactivate {
  abstract hasUnsavedChanges(): boolean;

  @HostListener("window:beforeunload", ["$event"])
  warnOnChanges($event) {
    if (this.hasUnsavedChanges()) {
      $event.returnValue = "Deine Änderungen werden nicht gespeichert!";
    }
  }
}
